export const TYPE_LABELS: Record<string, string> = {
  linkedin_post: 'LinkedIn Post',
  seo_article: 'SEO Article',
  comparison_page: 'Comparison Page',
  faq_page: 'FAQ Page',
  industry_page: 'Industry Page',
  use_case_page: 'Use Case Page',
  case_study: 'Case Study',
  glossary_entry: 'Glossary Entry',
  landing_page: 'Landing Page',
  integration_page: 'Integration Page',
  solution_page: 'Solution Page',
  feature_page: 'Feature Page',
};

export const LANG_LABELS: Record<string, string> = {
  en: 'EN',
  fr: 'FR',
  nl: 'NL',
  de: 'DE',
};

export const ICP_LABELS: Record<string, string> = {
  pharma_lifesciences: 'Pharma & life sciences',
  financial_services: 'Financial services',
  critical_infrastructure: 'Critical infrastructure',
  professional_services: 'Professional services',
  enterprise_saas: 'Enterprise SaaS',
  facility_management: 'Facility management',
  defense: 'Defence',
  general: 'General',
};
